'use client';

import { useEffect } from 'react';
import { logger } from '@/utils/logger';

export default function GlobalError({ error, reset }) {
  useEffect(() => {
    logger.error('Frontend Global Error caught:', error);
  }, [error]);

  return (
    <html>
      <body>
        <div style={{ minHeight: '100vh', fontFamily: 'sans-serif', padding: '1rem' }}>
          <button
            onClick={() => reset()}
            style={{ padding: '0.4rem 0.75rem', backgroundColor: '#111', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '12px' }}
          >
            Retry
          </button>
        </div>
      </body>
    </html>
  );
}
